export default {
  title: 'Afrekenen',
};
